import React from 'react';
import { faCircleHalfStroke } from '@fortawesome/pro-regular-svg-icons/faCircleHalfStroke';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CircleHalfStrokeRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCircleHalfStroke} {...props} />;
}
